export default {
    '/': 'FIREBIRD_TAB_HOME',
    '/developer': 'DEVELOPER_TAB',
    '/basic': 'SHARED_TAB_TOOLTIP_BASIC',
    '/home': 'FIREBIRD_TAB_HOME',

    '/system': 'SHARED_TAB_SYSTEM',
    '/system/companies': 'LEFTMENU_SYS_HEADER_COMPANYREGISTER',
    '/system/companies/active': 'LEFTMENU_SYS_COMPANYREGISTER_ACTIVECOMPANIES',
    '/system/companies/free': 'LEFTMENU_SYS_COMPANYREGISTER_FREELOADERS',
    '/system/companies/trials/active': 'LEFTMENU_SYS_COMPANYREGISTER_ACTIVETRIALS',
    '/system/companies/barred': 'LEFTMENU_SYS_COMPANYREGISTER_BARRED',
    '/system/companies/deregistered': 'LEFTMENU_SYS_COMPANYREGISTER_DEREGISTERED',
    '/system/companies/inactive': 'LEFTMENU_SYS_COMPANYREGISTER_INACTIVE',
    '/system/companies/trials': 'LEFTMENU_SYS_COMPANYREGISTER_DEMOCOMPANIES',
    '/system/companies/jira': 'LEFTMENU_SYS_COMPANYREGISTER_JIRAISSUES',
    '/system/companies/trials/master': 'LEFTMENU_SYS_COMPANYREGISTER_DEMOMASTERCOMPANIES',
    '/system/companies/presentations': 'LEFTMENU_SYS_COMPANYREGISTER_PRESENTATIONS',
    '/system/companies/presentations/categories': 'LEFTMENU_SYS_COMPANYREGISTER_PRESENTATIONS_CATEGORIES',
    '/system/admins': 'LEFTMENU_SYS_HEADER_ADMINREGISTER',
    '/system/admins/active': 'LEFTMENU_SYS_ADMINREGISTER_ACTIVEADMINS',
    '/system/admins/barred': 'LEFTMENU_SYS_ADMINREGISTER_BARREDADMINS',
    '/system/admins/deregistered': 'LEFTMENU_SYS_ADMINREGISTER_DEREGISTEREDADMINS',
    '/system/admins/groups': 'LEFTMENU_SYS_ADMINS_ADMINGROUPS',
    '/system/admins/services': 'LEFTMENU_SYS_ADMINS_SERVICES',
    '/system/admins/user-education': 'LEFTMENU_SYS_ADMINS_USER_EDUCATION',
    '/system/notes': 'LEFTMENU_DIALOGUE_HEADER_NOTES',
    '/system/notes/follow-ups': 'LEFTMENU_DIALOGUE_NOTESTODOLIST',
    '/system/texts': 'LEFTMENU_SYS_HEADER_SYSTEMTEXTS',
    '/system/texts/popups/module': 'LEFTMENU_SYS_SYSTEMTEXTS_POPUPS_MODULE',
    '/system/texts/emails/notifications': 'LEFTMENU_SYS_SYSTEMTEXTS_EMAILS_NOTIFICATIONS',
    '/system/texts/emails/vctemplates': 'LEFTMENU_SYS_SYSTEMTEXTS_EMAILS_VCTEMPLATES',
    '/system/texts/emails/modules': 'LEFTMENU_SYS_SYSTEMTEXTS_EMAILS_MODULES',
    '/system/texts/popups/notifications': 'LEFTMENU_SYS_SYSTEMTEXTS_SYSTEMMESSAGES',
    '/system/texts/newsletter': 'LEFTMENU_SYS_SYSTEMTEXTS_NEWSLETTER',
    '/system/edition': 'FORM_SYS_EDITION_SETTING_TITLE',
    '/system/edition/settings': 'FORM_SYS_EDITION_SETTING_TITLE',
    '/system/edition/finance-codes': 'FORM_SYS_EDITION_FINANCE_CODES',
    '/system/edition/dashboard': 'LEFTMENU_SYS_HEADER_DASHBOARD',
    '/system/invoicing': 'LEFTMENU_SYS_INVOICING',
    '/system/statistics': 'LEFTMENU_SYS_HEADER_STATISTICS',
    '/system/statistics/subscriptions': 'LEFTMENU_SYS_STATISTICS_BASIS',
    '/system/statistics/signups': 'LEFTMENU_SYS_STATISTICS_SIGNUPS',
    '/system/statistics/deregistrations': 'LEFTMENU_SYS_STATISTICS_DEREGISTRATIONS',
    '/system/statistics/admin-notes': 'LEFTMENU_SYS_STATISTICS_ADMIN_NOTES',
    '/system/statistics/invoice-basis': 'LEFTMENU_SYS_STATISTICS_INVOICE_BASIS',
    '/system/advanced': 'LEFTMENU_SYS_ADVANCED',
    '/system/advanced/commands': 'LEFTMENU_SYS_ADVANCED_COMMANDS',
    '/system/feedback': 'LEFTMENU_SYS_FEEDBACK',
    '/system/feedback/user-panel': 'LEFTMENU_SYS_FEEDBACK_USER_PANEL',
    '/system/feedback/inventory-feedback-group': 'LEFTMENU_SYS_FEEDBACK_INVENTORY_FEEDBACK_GROUP',
    '/system/addons': 'LEFTMENU_SYS_HEADER_ADDONMANAGEMENT',
    '/system/addons/management': 'LEFTMENU_SYS_ADDONS_MANAGE',
    '/system/addons/mobile': 'LEFTMENU_SYS_MOBILE_MANAGE',
    '/system/addons/store': 'LEFTMENU_SYS_STORE_MANAGE',
    '/system/addons/campaign': 'LEFTMENU_SYS_COMPANYREGISTER_MARKET_CAMPAIGNS',
    '/system/addons/switcher-feedback': 'LEFTMENU_SYS_SWITCHER_FEEDBACK',
    '/system/feedback/addon-deregister': 'LEFTMENU_SYS_FEEDBACK_ADDON_DEREGISTER',
    '/system/feedback/feature-feedback': 'LEFTMENU_SYS_FEEDBACK_FEATURE_FEEDBACK',

    '/admin': 'LEFTMENU_ADMIN_HEADER_ADMIN',
    '/admin/master-information': 'LEFTMENU_ADMIN_BASEINFO',
    '/admin/users': 'LEFTMENU_ADMIN_USERS',
    '/admin/services': 'LEFTMENU_ADMIN_SERVICES',
    '/admin/website-text': 'LEFTMENU_ADMIN_WEBSITEINFO',
    '/admin/social-media': 'LEFTMENU_ADMIN_MEDIAREPRESENTATION',
    '/admin/certifications': 'LEFTMENU_ADMIN_AUTHORIZATIONS',
    '/admin/log': 'LEFTMENU_ADMIN_LOG',
    '/admin/companies': 'LEFTMENU_ADMIN_COMPANYREGISTER',
    '/admin/companies/prices': 'LEFTMENU_ADMIN_PRICE_LIST',
    '/admin/companies/request-access': 'LEFTMENU_ADMIN_REQUESTACCESS',
    '/admin/companies/report-cover-templates': 'LEFTMENU_ADMIN_REPORTCOVERTEMPLATES',
    '/admin/defaults': 'LEFTMENU_ADMIN_HEADER_STANDARDOPS',
    '/admin/defaults/setups': 'LEFTMENU_ADMIN_STANDARDOPS',
    '/admin/defaults/accounts': 'LEFTMENU_ADMIN_ACCOUNTS',
    '/admin/defaults/mirror-codes': 'LEFTMENU_MIRRORCODES',
    '/admin/defaults/system-accounts': 'LEFTMENU_ADMIN_SYSTEMACCOUNTS',
    '/admin/defaults/vat-codes': 'LEFTMENU_ADMIN_VATACCOUNTS',
    '/admin/defaults/charge-accounts': 'LEFTMENU_ADMIN_TAXACCOUNTS',
    '/admin/defaults/groups': 'LEFTMENU_ADMIN_GROUPS',
    '/admin/defaults/groups/suppliers': 'LEFTMENU_ADMIN_PAYABLESGROUPS',
    '/admin/defaults/groups/customers': 'LEFTMENU_ADMIN_RECEIVABLESGROUPS',
    '/admin/defaults/groups/products': 'LEFTMENU_ADMIN_GOODSGROUPS',
    '/admin/defaults/groups/assets': 'LEFTMENU_ADMIN_ASSET_GROUPS',
    '/admin/defaults/units': 'LEFTMENU_ADMIN_UNITS',
    '/admin/defaults/journals': 'LEFTMENU_ADMIN_LEDGERS',
    '/admin/defaults/payment-terms': 'LEFTMENU_ADMIN_PAYMENTTERMS',
    '/admin/defaults/design-and-layout': 'LEFTMENU_ADMIN_DESIGNLAYOUT',
    '/admin/defaults/number-series': 'LEFTMENU_SETTINGS_NUMBERSERIES_UNBROKEN',
    '/admin/report-designer': 'LEFTMENU_ADMIN_HEADER_ANNUALREPORT2',
    '/admin/report-designer/templates': 'LEFTMENU_ADMIN_ARD2_TEMPLATES',
    '/admin/report-designer/company-groups': 'LEFTMENU_ADMIN_COMPANYGROUPS',

    '/sales': 'FIREBIRD_TAB_SALES',
    '/sales/invoicing': 'FIREBIRD_LEFTMENU_SALES_SECTIONHEADER_INVOICING',
    '/sales/invoicing/invoices': 'FIREBIRD_LEFTMENU_SALES_CURRENTINVOICES',
    '/sales/invoicing/invoices/new': 'FIREBIRD_LEFTMENU_SALES_NEWINVOICE',
    '/sales/invoicing/quotations': 'FIREBIRD_LEFTMENU_SALES_QUOTATIONS',
    '/sales/invoicing/quotations/new': 'FIREBIRD_LEFTMENU_SALES_NEWQUOTE',
    '/sales/invoicing/orders': 'FIREBIRD_LEFTMENU_SALES_ORDERS',
    '/sales/invoicing/orders/new': 'FIREBIRD_LEFTMENU_SALES_NEWORDER',
    '/sales/invoicing/reminders': 'FIREBIRD_LEFTMENU_SALES_REMINDERS',
    '/sales/invoicing/archive': 'FIREBIRD_LEFTMENU_SALES_ARCHIVE',
    '/sales/invoicing/archive/invoices': 'FIREBIRD_LEFTMENU_SALES_ARCHIVE_INVOICES',
    '/sales/invoicing/sent': 'FIREBIRD_LEFTMENU_SALES_SENT',
    '/sales/invoicing/instant-payment': 'FIREBIRD_LEFTMENU_INSTANT_PAYMENT_DASHBOARD',
    '/sales/invoicing/subscription': 'FIREBIRD_LEFTMENU_SALES_SUBSCRIPTION',
    '/sales/invoicing/pbs': 'FIREBIRD_LEFTMENU_SALES_PBS',
    '/sales/invoicing/avtalegiro': 'FIREBIRD_LEFTMENU_SALES_AVTALEGIRO',
    '/sales/invoicing/autogiro': 'FIREBIRD_LEFTMENU_SALES_AUTOGIRO',
    '/sales/invoicing/manual-invoices': 'FIREBIRD_LEFTMENU_SALES_MANUAL_CUSTOMER_INVOICES',
    '/sales/customers': 'FIREBIRD_LEFTMENU_SALES_CUSTOMERS',
    '/sales/customers/groups': 'FIREBIRD_LEFTMENU_SALES_CUSTOMERGROUPS',
    '/sales/customers/ledger-cards': 'FIREBIRD_LEFTMENU_SALES_CUSTOMERLEDGERCARDS',
    '/sales/products': 'FIREBIRD_LEFTMENU_SALES_PRODUCTS',
    '/sales/products/groups': 'FIREBIRD_LEFTMENU_SALES_PRODUCTGROUPS',
    '/sales/setup': 'FIREBIRD_LEFTMENU_SALES_SECTIONHEADER_SETUP',
    '/sales/setup/customer': 'FIREBIRD_LEFTMENU_SALES_CUSTOMERSETUP',
    '/sales/setup/payment-terms': 'FIREBIRD_LEFTMENU_SALES_PAYMENTTERMS',
    '/sales/setup/units': 'FIREBIRD_LEFTMENU_SALES_UNITS',
    '/sales/setup/design-and-layout': 'FIREBIRD_LEFTMENU_SALES_DESIGNANDLAYOUT',
    '/sales/setup/employees': 'FIREBIRD_LEFTMENU_SALES_EMPLOYEES',
    '/sales/setup/rot-deduction': 'FIREBIRD_LEFTMENU_SALES_ROTDEDUCTION',
    '/sales/setup/discount-groups': 'FIREBIRD_LEFTMENU_SALES_DISCOUNTGROUPS',
    '/sales/setup/email-templates': 'LEFTMENU_EMAILTEMPLATES',

    '/accounting': 'FIREBIRD_TAB_BOOKKEEPING',
    '/accounting/journals': 'LEFTMENU_LEDGER_HEADER_LEDGERS',
    '/accounting/lists': 'LEFTMENU_LEDGER_HEADER_FILES',
    '/accounting/lists/accounts': 'LEFTMENU_LEDGER_FILES_ACCOUNTS',
    '/accounting/lists/mirror-codes': 'LEFTMENU_MIRRORCODES',
    '/accounting/lists/suppliers': 'LEFTMENU_LEDGER_FILES_PAYABLES',
    '/accounting/lists/assets': 'LEFTMENU_LEDGER_ASSETS',
    '/accounting/lists/entries': 'LEFTMENU_LEDGER_FILES_RECORDS',
    '/accounting/lists/prepayments': 'LEFTMENU_LEDGER_ACCRUALS',
    '/accounting/lists/balance-posting': 'LEFTMENU_LEDGER_BALANCEPOSTING',
    '/accounting/document-requests': 'LEFTMENU_LEDGER_HEADER_DOCUMENTREQUESTS',
    '/accounting/document-requests/entries-without-documents': 'LEFTMENU_LEDGER_DOCUMENTREQUESTS_ENTRIES',
    '/accounting/document-requests/review': 'LEFTMENU_LEDGER_DOCUMENTREQUESTS_REVIEW',
    '/accounting/bank': 'LEFTMENU_BANK_HEADER',
    '/accounting/bank/reconciliation': 'LEFTMENU_BANKRECONCILIATION_LIST',
    '/accounting/bank/smartpay': 'LEFTMENU_LEDGER_SMARTPAY',
    '/accounting/bank/payments': 'LEFTMENU_LEDGER_PAYMENTS',
    '/accounting/bank/accounts': 'LEFTMENU_LEDGER_BANK_ACCOUNTS',
    '/accounting/bank/accounts/nordea': 'LEFTMENU_LEDGER_BANK_ACCOUNTS_NORDEA',
    '/accounting/payroll': 'LEFTMENU_LEDGER_HEADER_LOEN',
    '/accounting/payroll/danloen': 'LEFTMENU_LEDGER_INTEGRATION_DANLOEN',
    'https://www.danlon.dk/': 'LEFTMENU_LEDGER_INTEGRATION_DANLOEN',
    'https://dataloen.bluegarden.dk': 'LEFTMENU_LEDGER_INTEGRATION_DATALOEN',
    'https://mit.proloen.dk/#!/login': 'LEFTMENU_LEDGER_INTEGRATION_PROLOEN',
    '/accounting/payroll/fi-notifications': 'LEFTMENU_LEDGER_INTEGRATION_FIADVICES',
    '/accounting/payroll/pbs-notifications': 'LEFTMENU_LEDGER_INTEGRATION_PBSADVICES',
    '/accounting/integration': 'LEFTMENU_LEDGER_HEADER_INTEGRATION',
    '/accounting/integration/import-kid-ocr-fbo': 'LEFTMENU_LEDGER_INTEGRATION_IMPORTKIDOCRFBO',
    '/accounting/integration/golfbox': 'GolfBox',
    '/accounting/scanning': 'LEFTMENU_LEDGER_HEADER_SCANNING',
    '/accounting/scanning/incoming': 'LEFTMENU_LEDGER_SCANNING_TRANSFERPICS',
    '/accounting/scanning/upload': 'LEFTMENU_LEDGER_SCANNING_UPLOAD',
    '/accounting/scanning/unprocessed': 'LEFTMENU_LEDGER_SCANNING_UNPROCESSED',
    '/accounting/scanning/archive': 'LEFTMENU_LEDGER_SCANNING_ARCHIVE',
    '/accounting/scanning/failed': 'FAILED_ATTACHMENTS_MENU_POINT',
    '/accounting/scanning/categories': 'LEFTMENU_LEDGER_SCANNING_CATEGORIES',

    '/reports': 'FIREBIRD_TAB_REPORT',
    '/reports/statements': 'LEFTMENU_REPORTS_HEADER_REGNSKAB',
    '/reports/statements/period-total': 'LEFTMENU_REPORTS_BALANCE',
    '/reports/statements/profit-and-loss': 'LEFTMENU_REPORTS_PROFITANDLOSS',
    '/reports/statements/department-profit-and-loss': 'LEFTMENU_REPORTS_PROFITANDLOSSDEPARTMENT',
    '/reports/statements/balance-sheet': 'LEFTMENU_REPORTS_BALANCESHEET',
    '/reports/statements/balance-posting': 'LEFTMENU_REPORTS_TRIALBALANCE',
    '/reports/statements/key-figures': 'LEFTMENU_REPORTS_KEYFIGURES',
    '/reports/statements/budget': 'LEFTMENU_REPORTS_BUDGET',
    '/reports/statements/ledger-cards': 'LEFTMENU_REPORTS_ACCOUNTPOSTS',
    '/reports/statements/entries': 'LEFTMENU_REPORTS_POSTS',
    '/reports/statements/accounts': 'LEFTMENU_REPORTS_ACCOUNTS',
    '/reports/statements/report-designer': 'LEFTMENU_REPORTS_REPORTDESIGNER',
    '/reports/statements/assets': 'LEFTMENU_REPORTS_ASSET',
    '/reports/statements/prepayments': 'LEFTMENU_REPORT_ACCRUALS',
    '/reports/statements/journals': '',

    '/reports/other': 'LEFTMENU_REPORTS_COUNTRY_REPORTS',
    '/reports/customers': 'LEFTMENU_REPORTS_CUSTOMERLIST',
    '/reports/customers/ledger-cards': 'LEFTMENU_REPORTS_RECEIVABLESPOSTS',
    '/reports/customers/aged-debtors': 'LEFTMENU_REPORTS_ACCOUNTSRECEIVABLE',
    '/reports/customers/turnover': 'LEFTMENU_REPORTS_TURNOVER',
    '/reports/customers/account-reconciliation': 'LEFTMENU_REPORTS_CUSTOMERS_CONTROLACCOUNTRECONCILIATION',
    '/reports/suppliers': 'LEFTMENU_REPORTS_HEADER_SUPPLIERS',
    '/reports/suppliers/ledger-cards': 'LEFTMENU_REPORTS_PAYABLESPOSTS',
    '/reports/suppliers/aged-creditors': 'LEFTMENU_REPORTS_ACCOUNTSPAYABLE',
    '/reports/suppliers/purchase': 'LEFTMENU_REPORTS_PURCHASE_STATISTICS',
    '/reports/suppliers/account-reconciliation': 'LEFTMENU_REPORTS_SUPPLIERS_CONTROLACCOUNTRECONCILIATION',
    '/reports/vat': 'LEFTMENU_REPORTS_HEADER_VAT',
    '/reports/vat/statement': 'FORM_VAT_STATEMENT_GENERIC',
    '/reports/vat/statement-old': 'FORM_VAT_STATEMENT_OLD',
    '/reports/vat/detail': 'LEFTMENU_REPORTS_VATCHECK',
    '/reports/vat/eu-sales': 'LEFTMENU_REPORTS_SALES_TO_EU_CUSTOMERS',
    '/reports/vat/b2c-eu-sales': 'LEFTMENU_REPORTS_B2C_SALES_TO_EU_CUSTOMERS',
    '/reports/vat/archive': 'FORM_VAT_STATEMENT_ARCHIVE',
    '/reports/vat/ltlv': 'VAT-LTLV',
    '/reports/vat/ltlv/sales': 'VAT-LTLV Sales',
    '/reports/vat/ltlv/buy': 'VAT-LTLV Buy',
    '/reports/vat/ltlv/sales-abroad': 'VAT-LTLV Sales EU/Abr.',
    '/reports/vat/ltlv/buy-abroad': 'VAT-LTLV Buy EU/Abr.',
    '/reports/projects': 'LEFTMENU_REPORTS_HEADER_PROJECT',
    '/reports/projects/balance': 'LEFTMENU_REPORTS_CASETOTALS',
    '/reports/projects/variance': 'LEFTMENU_REPORTS_CASECOVERAGE',
    '/reports/projects/entries': 'LEFTMENU_REPORTS_CASEPOSTS',
    '/reports/projects/cards': 'LEFTMENU_REPORTS_CASECARD',
    '/reports/projects/value': 'LEFTMENU_REPORTS_PROJECTVALUE',
    '/reports/projects/employees': 'LEFTMENU_REPORTS_EMPLOYEESTATS',
    '/reports/projects/employees/reimbursement': 'LEFTMENU_REPORTS_EMPLOYEEREIMBURSEMENT',
    '/reports/projects/employees/cards': 'LEFTMENU_REPORTS_EMPLOYEECARD',
    '/reports/liability': 'LEFTMENU_REPORTS_HEADER_LIABILITYACCOUNTING',
    '/reports/liability/balance': 'LEFTMENU_REPORTS_LIABILITYTOTALS',
    '/reports/liability/adjustment': 'LEFTMENU_REPORTS_LIABILITYREGULATION',
    '/reports/inventory': 'LEFTMENU_REPORTS_HEADER_STOCK',
    '/reports/inventory/product-ledger-cards': 'LEFTMENU_REPORTS_GOODSACCOUNTCARD',
    '/reports/inventory/book-value': 'LEFTMENU_REPORTS_FINANCESTOCKVALUE',
    '/reports/inventory/stock-taking': 'LEFTMENU_REPORTS_STOCKCOUNT',
    '/reports/inventory/reordering': 'LEFTMENU_REPORTS_REORDER',
    '/reports/inventory/purchase-statistics': 'NYETS_LEFTMENU_REPORTS_BUYSTATS',

    '/inventory': 'FIREBIRD_TAB_INVENTORY',
    '/inventory/purchases': 'FIREBIRD_LEFTMENU_INVENTORY_HEADER_PURCHASES',
    '/inventory/purchases/orders': 'FIREBIRD_LEFTMENU_INVENTORY_PURCHASE_ORDERS',
    '/inventory/purchases/receipts': 'FIREBIRD_LEFTMENU_INVENTORY_RECEIPTS',
    '/inventory/purchases/invoices': 'FIREBIRD_LEFTMENU_INVENTORY_DRAFT_SUPPLIER_INVOICES',
    '/inventory/purchases/archive': 'FIREBIRD_LEFTMENU_INVENTORY_ARCHIVE',
    '/inventory/purchases/sent': 'FIREBIRD_LEFTMENU_INVENTORY_SENT_MAIL',
    '/inventory/suppliers': 'FIREBIRD_LEFTMENU_INVENTORY_SUPPLIERS',
    '/inventory/suppliers/groups': 'FIREBIRD_LEFTMENU_INVENTORY_SUPPLIERS_GROUP',
    '/inventory/products': 'FIREBIRD_LEFTMENU_INVENTORY_PRODUCTS',
    '/inventory/products/groups': 'FIREBIRD_LEFTMENU_SALES_PRODUCTGROUPS',
    '/inventory/products/units': 'FIREBIRD_LEFTMENU_INVENTORY_UNITS',
    '/inventory/products/categories': 'FIREBIRD_LEFTMENU_INVENTORY_CATEGORIES',
    '/inventory/products/collections': 'FIREBIRD_LEFTMENU_INVENTORY_PRODUCT_COLLECTIONS',
    '/inventory/products/discount-groups': 'FIREBIRD_LEFTMENU_INVENTORY_DISCOUNT_GROUPS',
    '/inventory/products/price-groups': 'FIREBIRD_LEFTMENU_INVENTORY_PRICE_GROUPS',
    '/inventory/products/language-groups': 'FIREBIRD_LEFTMENU_INVENTORY_LANGUAGE_GROUPS',
    '/inventory/deliveries': 'FIREBIRD_LEFTMENU_INVENTORY_DELIVERY_NOTES',
    '/inventory/deliveries/archive': 'FIREBIRD_LEFTMENU_INVENTORY_DELIVERY_NOTES_ARCHIVE',
    '/inventory/deliveries/locations': 'FIREBIRD_LEFTMENU_INVENTORY_LOCATIONS',
    '/inventory/books': 'FIREBIRD_LEFTMENU_INVENTORY_HEADER_INVENTORY_JOURNALS',
    '/inventory/books/:draftNumber': '',

    '/projects': 'FIREBIRD_TAB_PROJECT',
    '/projects/cases': 'LEFTMENU_PROJECT_HEADER_CASES',
    '/projects/cases/current': 'LEFTMENU_PROJECT_CURRENTCASES',
    '/projects/cases/closed': 'LEFTMENU_PROJECT_CLOSEDCASES',
    '/projects/cases/templates': 'LEFTMENU_PROJECT_CASETEMPLATES',
    '/projects/setup': 'LEFTMENU_PROJECT_HEADER_OTHEROPS',
    '/projects/setup/activities': 'LEFTMENU_PROJECT_ACTIVITIES',
    '/projects/setup/expenses': 'LEFTMENU_PROJECT_EXPENSES',
    '/projects/setup/statuses': 'LEFTMENU_PROJECT_CASESTATUSFILE',
    '/projects/setup/employees': 'LEFTMENU_PROJECT_EMPLOYEES',
    '/projects/setup/vacation': 'LEFTMENU_PROJECT_TIMEOFFETC',
    '/projects/setup/holidays': 'LEFTMENU_PROJECT_HOLIDAYS',
    '/projects/setup/entries': 'LEFTMENU_PROJECT_CASEPOSTS',
    '/projects/usage': 'LEFTMENU_PROJECT_HEADER_PRODUCTUSAGE',
    '/projects/responsibility': 'LEFTMENU_PROJECT_HEADER_PROJECTRESPONSIBILITY',
    '/projects/responsibility/projects': 'LEFTMENU_PROJECT_CASES',
    '/projects/responsibility/employees': 'LEFTMENU_PROJECT_EMPLOYEES',
    '/projects/responsibility/invoices': 'LEFTMENU_PROJECT_CURRENTINVOICES',
    '/projects/ledger': 'LEFTMENU_REPORTS_HEADER_LIABILITYACCOUNTING',
    '/projects/ledger/time-entry': 'LEFTMENU_PROJECT_CLIENTACCOUNTS',
    '/projects/entries': 'LEFTMENU_PROJECT_HEADER_REGS',
    '/projects/entries/time-entry': 'LEFTMENU_PROJECT_TIMEREG',
    '/projects/entries/mileage': 'LEFTMENU_PROJECT_DRIVINGREG',
    '/projects/entries/expenses': 'LEFTMENU_PROJECT_REIMBURSEMENTS',
    '/projects/groups': 'BASICMENU_ITEM_CASEGROUPS',
    '/projects/groups/projects': 'BASICMENU_ITEM_CASEGROUPS',
    '/projects/groups/cost': 'BASICMENU_ITEM_EXPENCEGROUPS',
    '/projects/groups/activity': 'BASICMENU_ITEM_ACTIVITYGROUPS',
    '/projects/groups/employee': 'BASICMENU_ITEM_EMPLOYEEGROUPS',

    '/journal-pro': 'FIREBIRD_TAB_JOURNALS',
    '/website': 'FIREBIRD_TAB_WEBSITE',
    '/webshop': 'FIREBIRD_TAB_WEBSHOP',
    '/webshop-plus': 'FIREBIRD_TAB_WEBSHOPPLUS',
    '/inbox': 'Inbox',
    '/market': 'Market',

    '/settings': 'SETTINGS_BTN_ALL_SETTINGS',
    '/settings/company': 'LEFTMENU_SETTINGS_HEADER_COMPANY',
    '/settings/company/master-information': 'LEFTMENU_SETTINGS_BASEINFO',
    '/settings/company/logo': 'Logo',
    '/settings/company/payment-link': 'LEFTMENU_SETTINGS_PAYMENTSOLUTIONS',
    '/settings/company/bank-accounts': 'LEFTMENU_LEDGER_BANKINFO',
    '/settings/company/electronic-invoicing': 'LEFTMENU_SETTINGS_ELECTRONIC_INVOICING',
    '/settings/company/electronic-invoicing-reception': 'LEFTMENU_SETTINGS_ELECTRONIC_INVOICING',
    '/settings/company/master-data-fields': 'LEFTMENU_SETTINGS_MOREINFO',
    '/settings/company/administrators': 'LEFTMENU_SETTINGS_ADMINS',
    '/settings/company/log': 'LEFTMENU_SETTINGS_LOG',
    '/settings/company/sent': 'LEFTMENU_SETTINGS_OUTGOINGMAIL',
    '/settings/company/export/data': 'LEFTMENU_SETTINGS_EXPORTDATA',
    '/settings/company/export/tripletex': 'TRIPLETEX_EXPORT_MENU_TITLE',
    '/settings/company/export/eAccounting': 'EACCOUNTING_EXPORT_MENUTITLE',
    '/settings/company/export/documents': 'LEFTMENU_SETTINGS_EXPORT_REGULAR_SCANNING_DOCUMENTS',
    '/settings/company/export/sie': 'LEFTMENU_SETTINGS_EXPORTSIE',
    '/settings/company/export/saf-t': 'LEFTMENU_SETTINGS_EXPORT_SAF_T',
    '/settings/company/export/caseware': 'LEFTMENU_SETTINGS_CASEWAREEXPORT',
    '/settings/company/anonymisation': 'LEFTMENU_SETTINGS_CUSTOMER_ANONYMIZATION',
    '/settings/company/new-features': 'LEFTMENU_SETTINGS_NEWFEATURES',
    '/settings/finance': 'FIREBIRD_LEFTMENU_SETTINGS_HEADER_FINANCIALSETUP',
    '/settings/finance/setups': 'LEFTMENU_SETTINGS_STANDARDOPS',
    '/settings/finance/accounts': 'LEFTMENU_SETTINGS_ACCOUNTS',
    '/settings/finance/mirror-codes': 'LEFTMENU_MIRRORCODES',
    '/settings/finance/accounts/system': 'LEFTMENU_SETTINGS_SYSTEMACCOUNTS',
    '/settings/finance/accounts/vat': 'LEFTMENU_SETTINGS_VATACCOUNTS',
    '/settings/finance/accounts/charge': 'LEFTMENU_SETTINGS_TAXACCOUNTS',
    '/settings/finance/journals': 'LEFTMENU_SETTINGS_LEDGERS',
    '/settings/finance/accounting-years': 'LEFTMENU_SETTINGS_FISCALYEARS',
    '/settings/finance/fixed-exchange-rates': 'LEFTMENU_SETTINGS_EXCHANGERATES',
    '/settings/groups': 'FIREBIRD_LEFTMENU_SETTINGS_HEADER_GROUPS',
    '/settings/groups/suppliers': 'LEFTMENU_SETTINGS_PAYABLESGROUPS',
    '/settings/groups/customers': 'LEFTMENU_SETTINGS_RECEIVABLESGROUPS',
    '/settings/groups/products': 'LEFTMENU_SETTINGS_GOODSGROUPS',
    '/settings/groups/assets': 'LEFTMENU_SETTINGS_ASSET_GROUPS',
    '/settings/categories-and-units': 'FIREBIRD_LEFTMENU_SETTINGS_HEADER_CATEGORIESANDUNITS',
    '/settings/categories-and-units/payment-terms': 'LEFTMENU_SETTINGS_PAYMENTTERMS',
    '/settings/categories-and-units/units': 'LEFTMENU_SETTINGS_UNITS',
    '/settings/categories-and-units/document-categories': 'LEFTMENU_SETTINGS_SCANNINGCATEGORIES',
    '/settings/categories-and-units/notes': 'LEFTMENU_SETTINGS_NOTETYPES',
    '/settings/categories-and-units/number-series': 'LEFTMENU_SETTINGS_NUMBERSERIES',
    '/settings/categories-and-units/unbroken-number-series': 'LEFTMENU_SETTINGS_NUMBERSERIES_UNBROKEN',
    '/settings/categories-and-units/change-of-numbers': 'LEFTMENU_SETTINGS_CHANGEOFNUMBERS',
    '/settings/categories-and-units/departments': 'LEFTMENU_SETTINGS_DEPARTMENTS',
    '/settings/inventory': 'FIREBIRD_LEFTMENU_SETTINGS_HEADER_STOCK',
    '/settings/inventory/books': 'LEFTMENU_SETTINGS_STOCKKLADDER',
    '/settings/extensions': 'LEFTMENU_SETTINGS_HEADER_EXTENSIBILITY',
    '/settings/extensions/web-hooks': 'LEFTMENU_SETTINGS_WEBHOOKS',
    '/settings/extensions/tabs': 'LEFTMENU_SETTINGS_EXTRA_TABS',
    '/settings/extensions/apps': 'LEFTMENU_SETTINGS_APPS',
    '/settings/extensions/website': 'LEFTMENU_SETTINGS_WEBSITE',
    '/settings/integrations': 'LEFTMENU_SETTINGS_HEADER_INTEGRATIONS',
    '/settings/integrations/smartbank': 'LEFTMENU_SETTINGS_SMARTBANK',
    '/settings/integrations/moneyflow': 'LEFTMENU_SETTINGS_SPOTFACTORING',
    '/settings/subscription': 'LEFTMENU_SETTINGS_HEADER_LICENSE',
    '/settings/subscription/status': 'LEFTMENU_SETTINGS_LICENSESTATUS',
    '/settings/subscription/users': 'LEFTMENU_SETTINGS_USERS',
    '/settings/subscription/modules': 'LEFTMENU_SETTINGS_MODULES',
    '/settings/subscription/extras': 'SYS_COMPANYREGISTER_COLBUTTON_ACCESSTOEXTRAFEATURES',

    '/user': 'LEFTMENU_MY_SETTINGS_TITLE',
    '/user/master-information': 'LEFTMENU_MY_SETTINGS_USER_INFO',
    '/user/log': 'LEFTMENU_MY_SETTINGS_LOG',
    '/user/feedback': 'LEFTMENU_MY_SETTINGS_FEEDBACK',
    '/user/feedback/panel': 'LEFTMENU_MY_SETTINGS_USER_PANEL',
    '/user/notes': 'LEFTMENU_DIALOGUE_HEADER_NOTES',
    '/user/notes/follow-ups': 'LEFTMENU_DIALOGUE_NOTESTODOLIST',
    '/user/notifications': 'LEFTMENU_MY_SETTINGS_NOTIFICATIONS',
    '/user/notifications/history': 'LEFTMENU_MY_SETTINGS_NOTIFICATIONS_HISTORY',
    '/user/notifications/settings': 'LEFTMENU_MY_SETTINGS_NOTIFICATIONS_SETTINGS',

    '/idea-bank': 'TOP_NAVIGATION_USERVOICE',
    '/chat': 'SHARED_TAB_TOOLTIP_CHAT',
    '/logout': 'TOPNAV_LOGOUT',
};
